<template>
    <div>
        <el-tree :props="props"
                :load="loadNode"
                :render-content="renderContent"
                 node-key="id"
                 :default-expanded-keys="expandedKeys"
                lazy>
        </el-tree>
    </div>
</template>

<script>
    import services from "../../services/common.service";
    export default {
        props:{
            callback:Function
        },
        data() {
            return {
                props: {
                    label: 'name',
                    children: 'zones',
                    isLeaf: 'leaf'
                },
                expandedKeys:[]
            }
        },
        created() {

        },
        methods: {
            loadNode(node, resolve){
                if (node.level === 0) {
                    services.getDepartmentList().then(res => {
                        res.list.map(item => {
                            this.expandedKeys.push(item.index);
                            if(!item.children){
                                item.leaf = true;
                            };
                            return item;
                        });
                        return resolve(res.list);

//                        res.departmentData.forEach(item => {
//                            this.expandedKeys.push(item.departmentId);
//                        });
//                        getLoadData(res.departmentData);
                    })
                };
                if(node.level === 0) return ;
                if(!node.isLeaf){     // 获取部门
                    let id = node.level === 1 ? node.data.departmentId : node.data.index;
                    services.departmentList(id).then(res => {
                        getLoadData(res.departmentData);
                    })
                };
                function getLoadData(arr) {
                    arr.map(item => {
                        item.id = item.departmentId || item.index;
                        if(!item.children){
                            item.leaf = true;
                        };
                        return item;
                    });
                    return resolve(arr);
                }
            },
            clickDepart(el,val){
                this.callback(el);
                this.$modal.close();
            },
            renderContent(h, { node, data, store}){
                if(!node.isLeaf){
                    return <span>{ node.label }</span>
                }else{
                    return <span onClick={this.clickDepart.bind(this,data)}>{ node.label }</span>
                }
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>